// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Donation Receipt Generator React components
import MDBox from "components/MDBox";

// Donation Receipt Generator React example components
import PageLayout from "examples/LayoutContainers/PageLayout";


function HomeLayout({ image, children }) {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox  width="100%" height="100vh" mx="auto">
        {/* <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%"> */}
          {/* <Grid item xs={11} sm={9} md={5} lg={4} xl={3}> */}
            {children}
          {/* </Grid> */}
        {/* </Grid> */}
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the HomeLayout
HomeLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default HomeLayout;
